// extracted by mini-css-extract-plugin
module.exports = {"title":"TopAlbums_title__3SfIO","album":"TopAlbums_album__3ko28"};